import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Flex,
  Heading,
  Text,
  Button,
  IconButton,
} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'

import {CrossIcon} from '../../icons'

const DismissRewardsBannerModal = ({
  isOpen,
  onClose,
  onHideForNow,
  onNeverShowAgain,
  isDismissing,
}) => {
  const {t} = useTranslation('onboarding')

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="12px" px="md" py="28px" maxW="468px">
        <ModalBody p="0">
          <Flex direction="column" gap="md">
            <Flex justify="space-between" align="flex-start" gap="sm">
              <Heading
                as="h2"
                fontFamily="body"
                fontWeight="normal"
                fontSize="2xl"
                lineHeight={1}
                letterSpacing={0}
              >
                {t('supplierRewardsBanner.dismissModal.title')}
              </Heading>
              <IconButton
                variant="unstyled"
                aria-label={t('supplierRewardsBanner.dismissModal.close')}
                icon={<CrossIcon boxSize="24px" />}
                onClick={onClose}
                minW="auto"
                h="24px"
                display="flex"
                alignItems="center"
              />
            </Flex>

            <Text textStyle="body-copy">
              {t('supplierRewardsBanner.dismissModal.description')}
            </Text>

            <Flex gap="20px" align="flex-start" flexWrap="wrap">
              <Button
                variant="primary"
                textTransform="uppercase"
                onClick={onHideForNow}
                isDisabled={isDismissing}
              >
                {t('supplierRewardsBanner.dismissModal.buttons.hideForNow')}
              </Button>
              <Button
                variant="secondary"
                textTransform="uppercase"
                onClick={onNeverShowAgain}
                isLoading={isDismissing}
                loadingText={t(
                  'supplierRewardsBanner.dismissModal.buttons.neverShowAgain',
                )}
              >
                {t('supplierRewardsBanner.dismissModal.buttons.neverShowAgain')}
              </Button>
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

DismissRewardsBannerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onHideForNow: PropTypes.func.isRequired,
  onNeverShowAgain: PropTypes.func.isRequired,
  isDismissing: PropTypes.bool,
}

DismissRewardsBannerModal.defaultProps = {
  isDismissing: false,
}

export default DismissRewardsBannerModal
